import { authFetchGET, authFetchPOST } from '../utils/auth-fetch';
import {VoyagePlan} from "../models/vessel-planning-model";
import { NextWaypointPayload, NextWaypointResult, RouteTypesPayload } from '../models/voyage-routing-model';
import { LatestNoPlanReminder } from './types/plans-service.types';

const env = (<any>window)["appenv"].services.plans;

export class PlansService {
    static async fetchPlans(imoNo: number, date: Date): Promise<Map<string, VoyagePlan>|null> {
        let rawPlans = await authFetchGET(
            env.scope,
            `${env.baseurl}/plans/${imoNo}`,
            { t: date.toISOString() });

        if (!rawPlans) {
            console.warn(`No plans found for IMO:${imoNo} at ${date.toISOString()}`);
            return null;
        }

        let plans:Map<string, VoyagePlan>|null = new Map<string, VoyagePlan>();
        for (const source in rawPlans) {
            plans.set(source, rawPlans[source])
        }

        return plans;
    }

    static async getNextWaypointIndex(payload: NextWaypointPayload) : Promise<NextWaypointResult>{
        return await authFetchPOST(env.scope, `${env.baseurl}/calculate-next-waypoint`, payload);
    }

    static async getRouteTypes(payload: RouteTypesPayload[]) : Promise<RouteTypesPayload[]>{
        try {
            return await authFetchPOST(env.scope, `${env.baseurl}/routetypes`, payload);
        }
        catch(e){
            console.log(e)
            return []
}       }
    
    static async getBasicVesselsList(): Promise<{imo: number, email: string}[]> {
        try {
            return await authFetchGET(env.scope, `${env.baseurl}/basicvessels`);
        }
        catch(e){
            console.log(e)
            return []
}       }

    static async getlatestNoPlanReminder(imo: number): Promise<LatestNoPlanReminder> {
        return await authFetchGET(env.scope, `${env.baseurl}/getlatestreminder/${imo}`);
    }
}
